import Vue from 'vue'
import mandMobile from 'mand-mobile'
import * as FastClick from "fastclick"
import App from './App'
import router from './router'
import store from './store';
import VeeValidate from "vee-validate";
import 'mand-mobile/lib/mand-mobile.css'
import './styles/global.css'


FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.use(mandMobile)
Vue.use(VeeValidate)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js